import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("lumora_cookie_consent")) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem("lumora_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-6">
      <div className="max-w-3xl mx-auto rounded-2xl bg-[#111111] text-white border border-white/10 shadow-2xl shadow-black/40 p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <Cookie size={22} className="text-[#E05638] shrink-0" />
        <p className="text-xs sm:text-sm text-neutral-300 leading-relaxed flex-1">
          Usiamo solo cookie tecnici per far funzionare il sito e — con il tuo ok — statistiche
          anonime sulle visite per migliorarlo. Niente pubblicità, niente profilazione. Dettagli nella{" "}
          <Link to="/privacy" data-testid="cookie-privacy-link" className="underline underline-offset-2 hover:text-[#E05638] transition-colors">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            data-testid="cookie-reject-button"
            onClick={() => choose("rejected")}
            className="rounded-full border border-white/25 text-neutral-300 px-5 py-2.5 text-xs font-medium hover:text-white transition-colors"
          >
            Rifiuta
          </button>
          <button
            data-testid="cookie-accept-button"
            onClick={() => choose("accepted")}
            className="rounded-full bg-[#E05638] text-white px-5 py-2.5 text-xs font-semibold hover:bg-[#C8452A] transition-colors"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
